import { createSelector } from 'reselect'

const selectHead = state => state.header

const selectHeader = createSelector(
  selectHead,
  header => header.header
)
const selectIsFetching = createSelector(
  selectHead,
  header => header.isFetching
)
const selectError = createSelector(
  selectHead,
  header => header.error
)

export {
  selectHeader,
  selectIsFetching,
  selectError
}



// WEBPACK FOOTER //
// ./src/containers/Header/selectors.js